import { changeAddressByOrderNumber } from '../api/shipping.api';

export const orderAddressUpdatedEvent = changeAddressByOrderNumber.matchFulfilled;
